import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { IconComponent } from '../../atoms/icon/icon.component';

let nextId = 0;

/**
 * One Help Center question that opens in place to show its answer, so people scan the
 * questions first and read only the answer they need. Works with `[(open)]`.
 */
@Component({
  selector: 'esn-faq-item',
  imports: [IconComponent],
  templateUrl: './faq-item.component.html',
  styleUrl: './faq-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqItemComponent {
  readonly question = input.required<string>();

  /**
   * Plain-text answer; richer answers can be projected as content instead (or in addition).
   */
  readonly answer = input('');

  /**
   * The hairline above the row; every row but a card's first has one.
   */
  readonly divider = input(true);
  readonly open = model(false);

  protected readonly buttonId = `esn-faq-item-${nextId++}`;
  protected readonly panelId = `${this.buttonId}-answer`;

  protected toggle(): void {
    this.open.update((open) => !open);
  }
}
